module.exports = "/_next/static/images/Nathan-993ddd1f5f291d374b739d206ce3e916.svg";